import $ from '../$';
import './each';
import './val';
/**
 * 将表单元素的值组合成键值对数组
 * @returns {Array}
 */

$.fn.serializeArray = function () {
  const result = [];
  this.each((_, element) => {
    const elements = element instanceof HTMLFormElement ? element.elements : [element];
    $(elements).each((_, element) => {
      const $element = $(element);
      const type = element.type;
      const nodeName = element.nodeName.toLowerCase();

      if (nodeName !== 'fieldset' && element.name && !element.disabled && ['input', 'select', 'textarea', 'keygen'].indexOf(nodeName) > -1 && ['submit', 'button', 'image', 'reset', 'file'].indexOf(type) === -1 && (['radio', 'checkbox'].indexOf(type) === -1 || element.checked)) {
        const value = $element.val();
        const valueArr = Array.isArray(value) ? value : [value];
        valueArr.forEach(value => {
          result.push({
            name: element.name,
            value
          });
        });
      }
    });
  });
  return result;
};